import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedTranslationModule } from '@shared/translation.module';

export type EntityType = 'logistics' | 'slaughterhouses' | 'byproducts' | 'services';

@Component({
  selector: 'md-pricing-entity-shortcuts',
  standalone: true,
  imports: [RouterLink, MatButtonModule, TranslateModule, SharedTranslationModule],
  templateUrl: './pricing-entity-shortcuts.component.html',
  styleUrls: ['./pricing-entity-shortcuts.component.scss']
})
export class PricingEntityShortcutsComponent {
  entityId = input<string>('');
  entityType = input<EntityType>('logistics');

  addPrice = output<void>();

  getEntityViewPath(): string[] {
    const basePath = '/app/view/';

    switch (this.entityType()) {
      case 'logistics':
        return [basePath + 'partners/logistics/', this.entityId()];
      case 'slaughterhouses':
        return [basePath + 'partners/slaughterhouses/', this.entityId()];
      case 'byproducts':
        return [basePath + 'products/byproducts/', this.entityId()];
      case 'services':
        return [basePath + 'services/', this.entityId()];
      default:
        return [basePath];
    }
  }

  onAddPriceClick(): void {
    this.addPrice.emit();
  }
}
